import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { FrState } from "./types";
import { RootState } from "../types";

const initialState: FrState = {};

export const fr: Module<FrState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
